import React, { useState, useEffect, useRef } from 'react';
import {
  Container,
  Row,
  Col,
  Button,
  Modal,
  CloseButton,
  Card,
  Form
} from 'react-bootstrap';
import BottomNav from '../BottomNav';
import { useTheme } from '../../ThemeContext';
import { VolumeUp, VolumeMute, MoonStars, Sliders, Sun, Share, InfoCircle, Trash, Phone, Tablet, Laptop, Display, PlayCircle, QuestionCircle, ChevronDown } from 'react-bootstrap-icons';
import { CSSTransition, TransitionGroup } from 'react-transition-group';
import Codee from '../ui/Codee';
import EmailDeliveryHintAlert from '../ui/EmailDeliveryHintAlert';
import { showGlassToast } from '../ui/GlassToast';
import { PUBLIC_URL } from '../../config/endpoints';

import { useAuth } from '../AuthContext';
import localforage from 'localforage'; // Добавляем localforage
import { Link, useNavigate } from 'react-router-dom';
const GLASS_MODE_STORAGE_KEY = 'salew:glass-disabled';


// Стандартные фильтры по умолчанию
const defaultFilters = [
  {
    "categ": "Мужчинам",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Женщинам",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Детям",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Все для девочек",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Все для мальчиков",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Дом",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Красота",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Аксессуары",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Электроника",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Игрушки",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Мебель",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Товары для взрослых",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Продукты",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Бытовая техника",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Зоотовары",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Спорт",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Автотовары",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Книги",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Ювелирные изделия",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Для ремонта",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Сад и дача",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Здоровье",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Канцтовары",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Другое",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "wb",
    "prod": true,
    "sale": 0,
    "ostatok": 1,
    "ai": 0,
    "feedbackminpercent": 50,
    "unrefusableallowed": true,
    "status_feedbacks": true
  },
  {
    "categ": "Ozon",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "ozon",
    "prod": null,
    "sale": 0,
    "ostatok": null,
    "ai": null,
    "feedbackminpercent": null,
    "unrefusableallowed": null,
    "status_feedbacks": null
  },
  {
    "categ": "Detmir",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "detmir",
    "prod": null,
    "sale": 0,
    "ostatok": null,
    "ai": null,
    "feedbackminpercent": null,
    "unrefusableallowed": null,
    "status_feedbacks": null
  },
  {
    "categ": "Yandex",
    "status_categ": true,
    "push": false,
    "user_status": false,
    "marketplace": "yandex",
    "prod": null,
    "sale": 0,
    "ostatok": null,
    "ai": null,
    "feedbackminpercent": null,
    "unrefusableallowed": null,
    "status_feedbacks": null
  }
];

const ProfilePage = () => {

  const navigate = useNavigate();
  const { theme, toggleTheme } = useTheme();
  const {
    filters,
    getFilters,
    updateFilters,
    userInfo,
    getPrig,
    referalInfo,
    isAuthenticated,
    isLoading,
    logout,
    isSoundEnabled,
    toggleSound,
    devices,
    getDevices,
    deleteDevice,
    currentDeviceId,
    getProfileEmailAuth,
    getProfileReferralLink,
    sendProfileEmailAuthCode,
    verifyProfileEmailAuthCode,
    startProfileTelegramLink,
    getProfileTelegramLinkStatus,
    finalizeProfileTelegramLink,
    getPublicProfile,
    checkPublicChatHandle,
    updatePublicProfile,
    uploadMedia,
    ensurePushToken,
  } = useAuth();
  const [modalShow, setModalShow] = useState(false);
  const [showFiltersModal, setShowFiltersModal] = useState(false);
  const [localFilters, setLocalFilters] = useState([]);
  const [isModified, setIsModified] = useState(false);
  const [showBulkWb, setShowBulkWb] = useState(false);
  const [bulkWbSettings, setBulkWbSettings] = useState({
    status_categ: true,
    push: false,
    prod: false,
    sale: 0,
    ai: 0,
    feedbackminpercent: 50,
    unrefusableallowed: false,
    status_feedbacks: false,
    ostatok: 0,
  });
  const [bulkWbInitialized, setBulkWbInitialized] = useState(false);
  const [errors, setErrors] = useState([]);
  const [notifToken, setNotifToken] = useState();
  const [isGlassDisabled, setIsGlassDisabled] = useState(() => {
    if (typeof window === 'undefined') {
      return false;
    }
    return window.localStorage.getItem(GLASS_MODE_STORAGE_KEY) === 'true';
  });

  const [showInfoModal, setShowInfoModal] = useState(false);
  const [pendingDiscount, setPendingDiscount] = useState(null);
  const [pendingFilterIndex, setPendingFilterIndex] = useState(null);
  const [hasShownDiscountInfo, setHasShownDiscountInfo] = useState(false);
  const [hasBackupFilters, setHasBackupFilters] = useState(false);

  const [showAiInfoModal, setShowAiInfoModal] = useState(false);
  const [hasShownAiInfo, setHasShownAiInfo] = useState(false);
  const [pendingAi, setPendingAi] = useState(null);
  const [pendingAiIndex, setPendingAiIndex] = useState(null);
  // 🆕 модалки‑помощники (бывшие Tooltip)
  const [saleHelpModal, setSaleHelpModal] = useState(false);
  const [aiHelpModal, setAiHelpModal] = useState(false);
  const [benefitHelpModal, setBenefitHelpModal] = useState(false);
  const [unrefHelpModal, setUnrefHelpModal] = useState(false);
  const [showGuideModal, setShowGuideModal] = useState(false);
  const [loadingDevices, setLoadingDevices] = useState(true);
  const [exitingDeviceId, setExitingDeviceId] = useState(null);
  const [profileEmailAuth, setProfileEmailAuth] = useState(null);
  const [profileEmailVerified, setProfileEmailVerified] = useState(false);
  const [telegramLinked, setTelegramLinked] = useState(false);
  const [emailAuthInput, setEmailAuthInput] = useState('');
  const [emailAuthCode, setEmailAuthCode] = useState('');
  const [emailAuthStep, setEmailAuthStep] = useState('email');
  const [emailAuthLoading, setEmailAuthLoading] = useState(false);
  const [emailAuthError, setEmailAuthError] = useState('');
  const [emailAuthInfo, setEmailAuthInfo] = useState('');
  const [showEmailDeliveryHint, setShowEmailDeliveryHint] = useState(false);
  const [telegramLinkHandshakeId, setTelegramLinkHandshakeId] = useState('');
  const [telegramLinkStatus, setTelegramLinkStatus] = useState('');
  const [telegramLinkLoading, setTelegramLinkLoading] = useState(false);
  const [telegramLinkError, setTelegramLinkError] = useState('');
  const [telegramLinkInfo, setTelegramLinkInfo] = useState('');
  const telegramLinkFinalizingRef = useRef(false);
  const [pwaReferralLink, setPwaReferralLink] = useState('');
  const [telegramReferralLink, setTelegramReferralLink] = useState('');
  const [publicDisplayName, setPublicDisplayName] = useState('');
  const [publicChatHandle, setPublicChatHandle] = useState('');
  const [publicContactLink, setPublicContactLink] = useState('');
  const [publicBio, setPublicBio] = useState('');
  const [publicAvatarUrl, setPublicAvatarUrl] = useState('');
  const [publicAvatarFile, setPublicAvatarFile] = useState(null);
  const [publicProfileSaving, setPublicProfileSaving] = useState(false);
  const [publicProfileError, setPublicProfileError] = useState('');
  const [publicProfileInfo, setPublicProfileInfo] = useState('');
  const [savedPublicChatHandle, setSavedPublicChatHandle] = useState('');
  const [publicProfileExpanded, setPublicProfileExpanded] = useState(false);
  const [publicHandleValidation, setPublicHandleValidation] = useState({
    state: 'idle',
    text: 'Логин можно оставить пустым.',
  });
  const publicHandleCheckSeqRef = useRef(0);

  const emailPattern = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
  const publicHandlePattern = /^[a-z0-9_]{3,32}$/;

  const getDeviceIcon = (deviceName) => {
    const name = deviceName?.toLowerCase() || '';
    if (name.includes('iphone') || name.includes('android') || name.includes('mobile')) {
      return <Phone size={24} className="text-primary" />;
    }
    if (name.includes('ipad') || name.includes('tablet')) {
      return <Tablet size={24} className="text-info" />;
    }
    if (name.includes('mac') || name.includes('windows') || name.includes('laptop')) {
      return <Laptop size={24} className="text-success" />;
    }
    return <Display size={24} className="text-warning" />;
  };

  const normalizeChatHandleInput = (value) => {
    const normalized = String(value || '').trim().toLowerCase();
    if (!normalized) return '';
    return normalized.startsWith('@') ? normalized.slice(1) : normalized;
  };

  const normalizePublicContactLink = (value) => {
    const rawValue = String(value || '').trim();
    if (!rawValue) {
      return { value: null, error: null };
    }

    if (rawValue.startsWith('@')) {
      const username = rawValue.slice(1).trim();
      if (!/^[A-Za-z0-9_]{3,32}$/.test(username)) {
        return {
          value: null,
          error: 'Telegram-контакт укажите как @username или ссылку t.me/username.',
        };
      }
      return { value: `https://t.me/${username}`, error: null };
    }

    if (/^tg:\/\/resolve\?/i.test(rawValue)) {
      try {
        const parsed = new URL(rawValue);
        const domain = String(parsed.searchParams.get('domain') || '').trim();
        if (!/^[A-Za-z0-9_]{3,32}$/.test(domain)) {
          throw new Error('invalid');
        }
        return { value: `https://t.me/${domain}`, error: null };
      } catch {
        return {
          value: null,
          error: 'Некорректная Telegram-ссылка. Используйте @username, t.me/username или tg://resolve?domain=username.',
        };
      }
    }

    let candidate = rawValue;
    if (!/^[a-z][a-z0-9+.-]*:\/\//i.test(candidate)) {
      candidate = `https://${candidate}`;
    }

    let parsedUrl;
    try {
      parsedUrl = new URL(candidate);
    } catch {
      return {
        value: null,
        error: 'Укажите только Telegram или MAX ссылку.',
      };
    }

    const host = String(parsedUrl.hostname || '').toLowerCase().replace(/^www\./, '');
    const path = String(parsedUrl.pathname || '').trim();

    if (host === 't.me' || host === 'telegram.me') {
      const telegramPath = path.replace(/^\/+/, '').replace(/\/+$/, '');
      if (!telegramPath) {
        return {
          value: null,
          error: 'Telegram-ссылка должна вести на username или приглашение.',
        };
      }
      return { value: `https://t.me/${telegramPath}`, error: null };
    }

    if (host === 'max.ru') {
      if (!path || path === '/') {
        return {
          value: null,
          error: 'MAX-ссылка должна вести на профиль или приглашение.',
        };
      }
      parsedUrl.protocol = 'https:';
      return { value: parsedUrl.toString(), error: null };
    }

    return {
      value: null,
      error: 'Для связи можно указать только Telegram или MAX.',
    };
  };

  const getPublicProfileInitials = (nameValue) => {
    const cleaned = String(nameValue || '').trim();
    if (!cleaned) return 'U';
    const parts = cleaned
      .split(/\s+/)
      .map((part) => part.trim())
      .filter(Boolean)
      .slice(0, 2);
    const initials = parts
      .map((part) => part.charAt(0))
      .join('')
      .toUpperCase();
    return initials || 'U';
  };

  const applyPublicProfileData = (profile) => {
    if (!profile) return;
    setPublicDisplayName(profile.display_name || '');
    const nextHandle = profile.chat_handle || '';
    setPublicChatHandle(nextHandle);
    setSavedPublicChatHandle(nextHandle);
    setPublicContactLink(profile.contact_link || '');
    setPublicBio(profile.bio || '');
    setPublicAvatarUrl(profile.avatar_thumb_url || profile.avatar_url || '');
    if (nextHandle) {
      setPublicHandleValidation({
        state: 'self',
        text: 'Это ваш текущий логин.',
      });
    } else {
      setPublicHandleValidation({
        state: 'idle',
        text: 'Логин можно оставить пустым.',
      });
    }
  };

  useEffect(() => {
    const rawHandle = String(publicChatHandle || '').trim();
    const normalizedHandle = normalizeChatHandleInput(rawHandle);
    const savedNormalizedHandle = normalizeChatHandleInput(savedPublicChatHandle);

    publicHandleCheckSeqRef.current += 1;
    const requestSeq = publicHandleCheckSeqRef.current;

    if (!rawHandle) {
      setPublicHandleValidation({
        state: 'idle',
        text: 'Логин можно оставить пустым.',
      });
      return undefined;
    }

    if (!publicHandlePattern.test(normalizedHandle)) {
      setPublicHandleValidation({
        state: 'invalid',
        text: '3-32 символа: латиница a-z, цифры 0-9 и _.',
      });
      return undefined;
    }

    if (normalizedHandle === savedNormalizedHandle) {
      setPublicHandleValidation({
        state: 'self',
        text: 'Это ваш текущий логин.',
      });
      return undefined;
    }

    setPublicHandleValidation({
      state: 'checking',
      text: 'Проверяем логин...',
    });

    const timerId = window.setTimeout(async () => {
      try {
        const resp = await checkPublicChatHandle(normalizedHandle);
        if (publicHandleCheckSeqRef.current !== requestSeq) return;

        const reason = String(resp?.reason || '').toLowerCase();
        const available = Boolean(resp?.available);

        if (available && reason === 'self') {
          setPublicHandleValidation({
            state: 'self',
            text: 'Это ваш текущий логин.',
          });
          return;
        }

        if (available) {
          setPublicHandleValidation({
            state: 'available',
            text: 'Логин свободен.',
          });
          return;
        }

        if (reason === 'taken') {
          setPublicHandleValidation({
            state: 'taken',
            text: 'Этот логин уже занят.',
          });
          return;
        }

        if (reason === 'invalid') {
          setPublicHandleValidation({
            state: 'invalid',
            text: '3-32 символа: латиница a-z, цифры 0-9 и _.',
          });
          return;
        }

        setPublicHandleValidation({
          state: 'error',
          text: 'Не удалось проверить логин. Повторите позже.',
        });
      } catch (error) {
        if (publicHandleCheckSeqRef.current !== requestSeq) return;
        setPublicHandleValidation({
          state: 'error',
          text: 'Не удалось проверить логин. Повторите позже.',
        });
      }
    }, 550);

    return () => {
      clearTimeout(timerId);
    };
  }, [
    checkPublicChatHandle,
    publicChatHandle,
    savedPublicChatHandle,
  ]);

  const handleSavePublicProfile = async () => {
    setPublicProfileSaving(true);
    setPublicProfileError('');
    setPublicProfileInfo('');
    try {
      const rawHandle = String(publicChatHandle || '').trim();
      const normalizedHandle = normalizeChatHandleInput(rawHandle);
      const savedNormalizedHandle = normalizeChatHandleInput(savedPublicChatHandle);
      const clearHandle = !rawHandle;
      const normalizedContact = normalizePublicContactLink(publicContactLink);

      if (!clearHandle && !publicHandlePattern.test(normalizedHandle)) {
        throw new Error('Логин некорректный: 3-32 символа, латиница, цифры и _.');
      }

      if (normalizedContact.error) {
        throw new Error(normalizedContact.error);
      }

      if (!clearHandle && normalizedHandle !== savedNormalizedHandle) {
        if (publicHandleValidation.state === 'checking') {
          throw new Error('Подождите, идет проверка логина.');
        }
        if (publicHandleValidation.state === 'taken') {
          throw new Error('Этот логин уже занят.');
        }
      }

      if (publicAvatarFile) {
        const mediaResp = await uploadMedia({
          profile: 'avatar',
          file: publicAvatarFile,
          applyToProfile: true,
        });
        if (!mediaResp?.status) {
          throw new Error('Не удалось загрузить аватар');
        }
        if (mediaResp.profile_data) {
          applyPublicProfileData(mediaResp.profile_data);
        }
      }

      const profileResp = await updatePublicProfile({
        display_name: publicDisplayName || null,
        chat_handle: clearHandle ? null : normalizedHandle,
        contact_link: normalizedContact.value,
        bio: publicBio || null,
      });
      if (!profileResp?.status) {
        throw new Error('Не удалось сохранить профиль');
      }
      applyPublicProfileData(profileResp.profile);
      setPublicAvatarFile(null);
      setPublicProfileInfo('Публичный профиль обновлен');
    } catch (error) {
      console.error('Ошибка сохранения публичного профиля:', error);
      setPublicProfileError(error?.message || 'Ошибка сохранения публичного профиля');
    } finally {
      setPublicProfileSaving(false);
    }
  };

  const handleDeleteDevice = async (deviceId) => {
    setExitingDeviceId(deviceId);
    // Анимация перед реальным удалением
    await new Promise(resolve => setTimeout(resolve, 300));
    await deleteDevice(deviceId);
    setExitingDeviceId(null);
  };
  useEffect(() => {
    const initializeAuth = async () => {
      if (isAuthenticated && !isLoading) {
        await getDevices();
        await getPrig();
        await getFilters();
        try {
          const emailState = await getProfileEmailAuth();
          if (emailState?.status) {
            const currentEmail = emailState.email_auth || emailState.receipt_email || '';
            setProfileEmailAuth(currentEmail || null);
            setProfileEmailVerified(Boolean(emailState.email_verified));
            setTelegramLinked(Boolean(emailState.telegram_linked));
            setEmailAuthInput(currentEmail || '');
          }
        } catch (error) {
          console.error('Ошибка загрузки email-настроек профиля:', error);
        }
        try {
          const referralResp = await getProfileReferralLink();
          if (referralResp?.status) {
            if (referralResp.pwa_referral_url) {
              setPwaReferralLink(referralResp.pwa_referral_url);
            }
            if (referralResp.telegram_referral_url) {
              setTelegramReferralLink(referralResp.telegram_referral_url);
            }
          }
        } catch (error) {
          console.error('Ошибка загрузки реферальной ссылки профиля:', error);
        }
        try {
          const publicProfileResp = await getPublicProfile();
          if (publicProfileResp?.status && publicProfileResp.profile) {
            applyPublicProfileData(publicProfileResp.profile);
          }
        } catch (error) {
          console.error('Ошибка загрузки публичного профиля:', error);
        }
        setLoadingDevices(false);
      }
    };
    initializeAuth();
  }, []);
  useEffect(() => {
    const syncGlassMode = () => {
      setIsGlassDisabled(window.localStorage.getItem(GLASS_MODE_STORAGE_KEY) === 'true');
    };

    window.addEventListener('storage', syncGlassMode);
    window.addEventListener('salew:glass-mode-changed', syncGlassMode);
    return () => {
      window.removeEventListener('storage', syncGlassMode);
      window.removeEventListener('salew:glass-mode-changed', syncGlassMode);
    };
  }, []);

  useEffect(() => {
    if (filters) {
      setLocalFilters(filters);
    }
  }, [filters]);

  useEffect(() => {
    if (!bulkWbInitialized && localFilters.length) {
      const firstWb = localFilters.find((f) => f.marketplace === 'wb');
      if (firstWb) {
        setBulkWbSettings({
          status_categ: firstWb.status_categ ?? true,
          push: firstWb.push ?? false,
          prod: firstWb.prod ?? false,
          sale: firstWb.sale ?? 0,
          ai: firstWb.ai ?? 0,
          feedbackminpercent: firstWb.feedbackminpercent ?? 50,
          unrefusableallowed: firstWb.unrefusableallowed ?? false,
          status_feedbacks: firstWb.status_feedbacks ?? false,
          ostatok: firstWb.ostatok ?? 0,
        });
        setBulkWbInitialized(true);
      }
    }
  }, [localFilters, bulkWbInitialized]);

  useEffect(() => {
    // Читаем, показывали ли уже инфо о скидке
    localforage.getItem('hasShownDiscountInfo').then((value) => {
      if (value === true) {
        setHasShownDiscountInfo(true);
      }
    });
    // Читаем, показывали ли уже инфо об AI
    localforage.getItem('hasShownAiInfo').then((value) => {
      if (value === true) {
        setHasShownAiInfo(true);
      }
    });
  }, []);

  useEffect(() => {
    localforage.getItem('backupFilters').then((backup) => {
      if (backup) setHasBackupFilters(true);
    });
  }, []);

  const handleGlassModeToggle = () => {
    const nextValue = !isGlassDisabled;
    window.localStorage.setItem(GLASS_MODE_STORAGE_KEY, String(nextValue));
    setIsGlassDisabled(nextValue);
    window.dispatchEvent(new Event('salew:glass-mode-changed'));
    showGlassToast(nextValue ? 'Упрощенный интерфейс включен' : 'Стеклянный режим включен', {
      variant: 'success',
      duration: 1800,
    });
  };

  const themeClass = theme === 'dark' ? 'text-white bg-dark' : 'text-dark bg-light';

  const subscriptionStatus = userInfo.status
    ? <div className={`subscription-status basic-subscription`}>Подписка Активна до {userInfo.until} по МСК </div>
    : <div className={`subscription-status no-subscription`}>Подписка закончилась {userInfo.until} по МСК </div>;

  const copyTextToClipboard = async (text) => {
    if (!text) return false;

    if (navigator.clipboard && window.isSecureContext) {
      try {
        await navigator.clipboard.writeText(text);
        return true;
      } catch (error) {
        console.warn('Clipboard API недоступен, fallback через textarea:', error);
      }
    }

    try {
      const textarea = document.createElement('textarea');
      textarea.value = text;
      textarea.setAttribute('readonly', '');
      textarea.style.position = 'fixed';
      textarea.style.opacity = '0';
      textarea.style.pointerEvents = 'none';
      textarea.style.left = '-9999px';
      document.body.appendChild(textarea);
      textarea.focus();
      textarea.select();
      textarea.setSelectionRange(0, textarea.value.length);
      const copied = document.execCommand('copy');
      document.body.removeChild(textarea);
      return copied;
    } catch (error) {
      console.error('Ошибка fallback-копирования:', error);
      return false;
    }
  };

  const copyRefLink = async () => {
    const primaryLink = pwaReferralLink || `${PUBLIC_URL}/r/${userInfo.user_id}`;
    const copied = await copyTextToClipboard(primaryLink);
    if (copied) {
      showGlassToast('Ссылка скопирована');
      return;
    }
    window.prompt('Скопируйте ссылку вручную:', primaryLink);
  };

  const handleShare = async () => {
    const shareUrl = pwaReferralLink || `${PUBLIC_URL}/r/${userInfo.user_id}`;
    const shareData = {
      title: 'Присоединяйтесь к SaleW боту!',
      text: 'Переходи по ссылке и покупай подписку!',
      url: shareUrl,
    };

    try {
      if (typeof navigator.share === 'function') {
        let nativePayload = shareData;
        if (typeof navigator.canShare === 'function') {
          try {
            if (!navigator.canShare(shareData)) {
              nativePayload = {
                title: shareData.title,
                text: `${shareData.text}\n${shareData.url}`,
              };
            }
          } catch (_) {
            nativePayload = shareData;
          }
        }

        await navigator.share(nativePayload);
        return;
      }
    } catch (err) {
      if (err?.name === 'AbortError') {
        return;
      }
      console.error('Ошибка при попытке поделиться: ', err);
    }

    const copied = await copyTextToClipboard(shareData.url);
    if (copied) {
      showGlassToast('Ссылка скопирована');
      return;
    }
    window.prompt('Скопируйте ссылку вручную:', shareData.url);
  };

  const requestFCMToken = async () => {
    return await ensurePushToken({ showInstructions: true });
  };

  const handleSendProfileEmailCode = async () => {
    const normalizedEmail = (emailAuthInput || '').trim().toLowerCase();
    if (!emailPattern.test(normalizedEmail)) {
      setEmailAuthError('Введите корректный email');
      return;
    }

    setEmailAuthLoading(true);
    setEmailAuthError('');
    setEmailAuthInfo('');
    try {
      const resp = await sendProfileEmailAuthCode(normalizedEmail);
      setEmailAuthInput(normalizedEmail);
      setEmailAuthStep('code');
      setProfileEmailVerified(false);
      setEmailAuthInfo(resp?.detail || 'Код отправлен на email');
      setShowEmailDeliveryHint(true);
    } catch (error) {
      setEmailAuthError(error.message || 'Не удалось отправить код');
    } finally {
      setEmailAuthLoading(false);
    }
  };

  const handleVerifyProfileEmailCode = async () => {
    const normalizedEmail = (emailAuthInput || '').trim().toLowerCase();
    const normalizedCode = (emailAuthCode || '').trim();

    if (!emailPattern.test(normalizedEmail)) {
      setEmailAuthError('Введите корректный email');
      return;
    }
    if (!/^\d{6}$/.test(normalizedCode)) {
      setEmailAuthError('Код должен состоять из 6 цифр');
      return;
    }

    setEmailAuthLoading(true);
    setEmailAuthError('');
    setEmailAuthInfo('');
    try {
      const resp = await verifyProfileEmailAuthCode(
        normalizedEmail,
        normalizedCode
      );
      setProfileEmailAuth(resp?.email_auth || normalizedEmail);
      setProfileEmailVerified(Boolean(resp?.email_verified));
      setTelegramLinked(Boolean(resp?.telegram_linked));
      setEmailAuthStep('email');
      setEmailAuthCode('');
      setEmailAuthInfo(resp?.detail || 'Email подтвержден');
    } catch (error) {
      setEmailAuthError(error.message || 'Не удалось подтвердить код');
    } finally {
      setEmailAuthLoading(false);
    }
  };

  const handleStartTelegramLink = async () => {
    if (telegramLinked || telegramLinkLoading) {
      return;
    }

    setTelegramLinkLoading(true);
    setTelegramLinkError('');
    setTelegramLinkInfo('');
    telegramLinkFinalizingRef.current = false;

    try {
      const resp = await startProfileTelegramLink();
      if (resp?.status === 'already_linked') {
        setTelegramLinked(true);
        setTelegramLinkStatus('completed');
        setTelegramLinkInfo(resp?.detail || 'Telegram уже привязан.');
        return;
      }

      const handshakeId = resp?.handshake_id;
      if (!handshakeId) {
        throw new Error(resp?.detail || 'Не удалось создать сессию привязки Telegram');
      }

      setTelegramLinkHandshakeId(handshakeId);
      setTelegramLinkStatus('pending');
      setTelegramLinkInfo('Откройте Telegram и подтвердите действие в боте.');

      const telegramWebUrl = resp?.telegram_web_url || `https://t.me/salew_bot?start=auth_${handshakeId}`;
      const telegramAppUrl = resp?.telegram_app_url || `tg://resolve?domain=salew_bot&start=auth_${handshakeId}`;
      let fallbackTimer = null;

      function handleVisibilityChange() {
        if (document.visibilityState === 'hidden') {
          cleanupFallback();
        }
      }

      function cleanupFallback() {
        if (fallbackTimer) {
          clearTimeout(fallbackTimer);
          fallbackTimer = null;
        }
        document.removeEventListener('visibilitychange', handleVisibilityChange);
      }

      window.location.href = telegramWebUrl;
      fallbackTimer = window.setTimeout(() => {
        if (!document.hidden) {
          window.location.href = telegramAppUrl;
        }
        cleanupFallback();
      }, 800);
      document.addEventListener('visibilitychange', handleVisibilityChange);
    } catch (error) {
      setTelegramLinkError(error.message || 'Не удалось начать привязку Telegram');
    } finally {
      setTelegramLinkLoading(false);
    }
  };

  useEffect(() => {
    if (!telegramLinkHandshakeId || telegramLinked) {
      return;
    }

    let active = true;
    let timerId = null;

    const refreshProfileState = async () => {
      try {
        const emailState = await getProfileEmailAuth();
        if (emailState?.status) {
          const currentEmail = emailState.email_auth || emailState.receipt_email || '';
          setProfileEmailAuth(currentEmail || null);
          setProfileEmailVerified(Boolean(emailState.email_verified));
          setTelegramLinked(Boolean(emailState.telegram_linked));
          if (currentEmail) {
            setEmailAuthInput(currentEmail);
          }
        }
      } catch (error) {
        console.error('Ошибка обновления профиля после привязки Telegram:', error);
      }
    };

    const pollStatus = async () => {
      if (!active) {
        return;
      }

      try {
        const statusResp = await getProfileTelegramLinkStatus(telegramLinkHandshakeId);
        const status = statusResp?.status;
        if (status) {
          setTelegramLinkStatus(status);
        }

        if (status === 'confirmed') {
          if (telegramLinkFinalizingRef.current) {
            return;
          }
          telegramLinkFinalizingRef.current = true;
          try {
            const finalizeResp = await finalizeProfileTelegramLink(telegramLinkHandshakeId);
            if (finalizeResp?.token || finalizeResp?.telegram_linked) {
              setTelegramLinked(true);
              setTelegramLinkStatus('completed');
              setTelegramLinkHandshakeId('');
              setTelegramLinkError('');
              setTelegramLinkInfo('Telegram успешно привязан.');
              await refreshProfileState();
              active = false;
              return;
            }
            if (finalizeResp?.detail && finalizeResp.detail !== 'handshake_pending') {
              setTelegramLinkError(finalizeResp.detail);
            }
          } catch (error) {
            setTelegramLinkError(error.message || 'Не удалось завершить привязку Telegram');
          } finally {
            telegramLinkFinalizingRef.current = false;
          }
        } else if (status === 'expired' || status === 'not_found') {
          setTelegramLinkError('Ссылка для привязки устарела. Запустите привязку заново.');
          setTelegramLinkHandshakeId('');
          setTelegramLinkStatus(status);
          active = false;
          return;
        } else if (status === 'completed') {
          setTelegramLinked(true);
          setTelegramLinkHandshakeId('');
          setTelegramLinkInfo('Telegram уже привязан.');
          await refreshProfileState();
          active = false;
          return;
        }
      } catch (error) {
        setTelegramLinkError(error.message || 'Не удалось проверить статус привязки Telegram');
      } finally {
        if (active) {
          timerId = window.setTimeout(pollStatus, 5000);
        }
      }
    };

    pollStatus();

    const handleVisibilityChange = () => {
      if (!document.hidden) {
        pollStatus();
      }
    };

    document.addEventListener('visibilitychange', handleVisibilityChange);

    return () => {
      active = false;
      if (timerId) {
        clearTimeout(timerId);
      }
      document.removeEventListener('visibilitychange', handleVisibilityChange);
      telegramLinkFinalizingRef.current = false;
    };
  }, [
    telegramLinkHandshakeId,
    telegramLinked,
    getProfileTelegramLinkStatus,
    finalizeProfileTelegramLink,
    getProfileEmailAuth,
  ]);

  const validateFilter = (filter, index) => {
    const error = {};

    if (
      filter.marketplace === 'wb' &&
      (filter.feedbackminpercent == null ||
        filter.feedbackminpercent < 50 ||
        filter.feedbackminpercent > 100)
    ) {
      error.feedbackminpercent = 'Должно быть от 50 до 100';
    }

    // Валидация остатка
    if (filter.ostatok !== undefined && filter.ostatok < 0) {
      error.ostatok = "Остаток не может быть отрицательным";
    }

    // Обновляем ошибки для текущего фильтра
    const newErrors = [...errors];
    newErrors[index] = error;
    setErrors(newErrors);

    // Если ошибок нет, возвращаем true
    return Object.keys(error).length === 0;
  };
  const handleFilterChange = async (index, field, value) => {
    const updatedFilters = [...localFilters];
    // Если меняем скидку — сначала показываем модалку, не меняем сразу состояние
    if (field === 'sale') {
      // Если еще не показывали окно о скидке
      if (!hasShownDiscountInfo) {
        setPendingDiscount(value);
        setPendingFilterIndex(index);
        setShowInfoModal(true);
        return;
      } else {
        // Если окно уже показывалось, можно сразу менять
        updatedFilters[index][field] = value;
      }
    }
    // 2) Проверка AI
    else if (field === 'ai') {
      // Если еще не показывали окно о нейросети
      if (!hasShownAiInfo) {
        setPendingAi(value);
        setPendingAiIndex(index);
        setShowAiInfoModal(true);
        return;
      } else {
        updatedFilters[index][field] = value;
      }
    }
    // 3) Все остальные поля (push, status_categ, ostatok и т.д.)
    else {
      updatedFilters[index][field] = value;
    }

    // Далее код, который обновляет localFilters и делает валидацию
    setLocalFilters(updatedFilters);
    setIsModified(true);

    if (field === 'push' && value === true) {
      const fcmToken = await requestFCMToken();
      if (fcmToken) {
        setNotifToken(fcmToken);
      } else {
        updatedFilters[index].push = false;
        setLocalFilters(updatedFilters);
      }
    }

    validateFilter(updatedFilters[index], index);
  };

  const handleBulkWbChange = (field, value) => {
    setBulkWbSettings((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const applyBulkWbSettings = async () => {
    if (!localFilters.length) return;

    let updatedFilters = localFilters.map((filter) =>
      filter.marketplace === 'wb'
        ? {
          ...filter,
          ...bulkWbSettings,
        }
        : filter
    );

    setLocalFilters(updatedFilters);
    setIsModified(true);

    if (bulkWbSettings.push) {
      const fcmToken = await requestFCMToken();
      if (fcmToken) {
        setNotifToken(fcmToken);
      } else {
        updatedFilters = updatedFilters.map((filter) =>
          filter.marketplace === 'wb' ? { ...filter, push: false } : filter
        );
        setLocalFilters(updatedFilters);
      }
    }

    updatedFilters.forEach((filter, index) => validateFilter(filter, index));
  };

  // Функция вызывается при нажатии "Понятно" в модалке
  const handleInfoModalConfirm = () => {
    const updatedFilters = [...localFilters];
    updatedFilters[pendingFilterIndex].sale = pendingDiscount;
    setLocalFilters(updatedFilters);
    setIsModified(true);

    // Закрываем модалку
    localforage.setItem('hasShownDiscountInfo', true);
    setHasShownDiscountInfo(true);
    setShowInfoModal(false);
    setPendingDiscount(null);
    setPendingFilterIndex(null);
  };
  // Функция вызывается при нажатии "Непонятно" в модалке
  const handleInfoModalCancel = () => {
    // Просто закрываем модалку без изменений
    setShowInfoModal(false);
    setPendingDiscount(null);
    setPendingFilterIndex(null);
  };
  const handleAiInfoModalConfirm = () => {
    const updatedFilters = [...localFilters];
    updatedFilters[pendingAiIndex].ai = pendingAi;
    setLocalFilters(updatedFilters);
    setIsModified(true);

    localforage.setItem('hasShownAiInfo', true);
    setHasShownAiInfo(true);
    setShowAiInfoModal(false);
    setPendingAi(null);
    setPendingAiIndex(null);
  };
  const handleAiInfoModalCancel = () => {
    setShowAiInfoModal(false);
    setPendingAi(null);
    setPendingAiIndex(null);
  };

  const handleSaveFilters = async () => {
    const isValid = localFilters.every((f, i) => validateFilter(f, i));
    if (!isValid) {
      showGlassToast('Пожалуйста, исправьте ошибки перед сохранением', { variant: 'error', duration: 3000 });
      return;
    }

    await updateFilters(localFilters, notifToken);
    localStorage.removeItem('cachedSales'); // ⚡ очищаем кэш прямо здесь
    setShowFiltersModal(false);
    setIsModified(false);
  };

  const handleModalClose = () => {
    if (isModified) {
      if (window.confirm('Сохранить изменения перед закрытием?')) {
        const isValid = localFilters.every((filter, index) => validateFilter(filter, index));
        if (isValid) {
          handleSaveFilters(); // Сохраняем и закрываем окно
          setShowFiltersModal(false); // Закрываем окно только если все валидно
        } else {
          showGlassToast('Пожалуйста, исправьте ошибки перед закрытием.', { variant: 'error', duration: 3000 });
          // Окно останется открытым для исправления ошибок
        }
      } else {
        setShowFiltersModal(false); // Закрываем окно без сохранения
      }
    } else {
      setShowFiltersModal(false); // Закрываем, если не было изменений
    }
  };

  const handleResetFilters = async () => {
    await localforage.setItem('backupFilters', localFilters);
    setHasBackupFilters(true);
    setLocalFilters(defaultFilters);
    setIsModified(true);
    showGlassToast('Фильтры сброшены. Для применения нажмите "Сохранить".', { duration: 4200 });
    setBulkWbInitialized(false);
  };

  // Возврат к сохранённым в backup фильтрам
  const handleRestoreFilters = async () => {
    const backup = await localforage.getItem('backupFilters');
    if (backup) {
      setLocalFilters(backup);
      setIsModified(true);
      // Удаляем backup из localforage
      await localforage.removeItem('backupFilters');
      setHasBackupFilters(false);
    }
  };

  const hasEmailAuthForLogin = Boolean(profileEmailVerified && profileEmailAuth);
  const hasUnverifiedProfileEmail = Boolean(profileEmailAuth && !profileEmailVerified);
  const isEmailCodeStep = emailAuthStep === 'code';
  const isEmailEditStep = emailAuthStep === 'edit';
  const showVerifiedEmailActions = profileEmailVerified && !isEmailEditStep && !isEmailCodeStep;
  const showEmailInput = !isEmailCodeStep && (!profileEmailVerified || isEmailEditStep);
  const isEmailOnlyAccount = !telegramLinked && hasEmailAuthForLogin;
  const isTelegramOnlyAccount = telegramLinked && !hasEmailAuthForLogin;
  const isTelegramPlusEmailAccount = telegramLinked && hasEmailAuthForLogin;
  const emailSectionTitle = showVerifiedEmailActions
    ? 'Email подтвержден'
    : hasUnverifiedProfileEmail
      ? 'Подтвердить email'
      : isTelegramOnlyAccount
        ? 'Добавить email для входа'
        : 'Email для входа';
  const supportTelegramUrl = 'https://t.me/SaleW_Support';
  const supportMaxUrl = 'https://max.ru/u/f9LHodD0cOLkybkMaACuMPTooxWoTrXIaccAneeGAfvHKvf7aKrFOq6HAvA';
  const emailSendCodeButtonText = isEmailEditStep
    ? 'Отправить код на новый email'
    : hasUnverifiedProfileEmail
      ? 'Отправить код подтверждения'
      : isTelegramOnlyAccount
        ? 'Добавить email для входа'
        : isTelegramPlusEmailAccount
          ? 'Обновить email'
          : 'Отправить код';
  const emailVerificationStatusText = isEmailEditStep
    ? 'Введите новый email. После отправки кода старый email будет заменен только после подтверждения.'
    : profileEmailVerified
      ? 'Email подтвержден.'
      : isEmailCodeStep
        ? 'Код отправлен. Введите 6 цифр из письма ниже.'
        : profileEmailAuth
          ? 'Email указан, но еще не подтвержден. Нажмите «Отправить код подтверждения», чтобы получить письмо.'
          : 'Email не подтвержден. Укажите email и отправьте код подтверждения.';
  const normalizedPublicHandle = normalizeChatHandleInput(publicChatHandle);
  const publicProfileSummaryHandle = normalizedPublicHandle ? `@${normalizedPublicHandle}` : 'Логин не задан';
  const publicProfileSummaryName = String(publicDisplayName || '').trim() || `User ${userInfo.user_id}`;
  const publicProfileInitials = getPublicProfileInitials(publicProfileSummaryName);
  const publicHandleValidationClass = publicHandleValidation.state === 'available' || publicHandleValidation.state === 'self'
    ? 'profile-public-handle-state--ok'
    : publicHandleValidation.state === 'checking'
      ? 'profile-public-handle-state--checking'
      : publicHandleValidation.state === 'taken' || publicHandleValidation.state === 'invalid' || publicHandleValidation.state === 'error'
        ? 'profile-public-handle-state--error'
        : '';

  return (
    <>
      <div className={`min-vh-100 ${themeClass} scrollable profile-page-shell profile-safe-top ${theme === 'dark' ? 'profile-page-shell--dark' : 'profile-page-shell--light'}`}>
        <div className={`profile-status-glass ${theme === 'dark' ? 'profile-status-glass--dark' : 'profile-status-glass--light'}`} aria-hidden="true" />

        <Container className="pt-3 pb-4">
          {/* Профиль */}
          <Row className="mb-3">
            <Col xs={12}>
              <div className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} style={{ borderRadius: '0.5rem' }}>
                <div className="card-body d-flex align-items-center justify-content-between p-3">
                  <h4 className="mb-0 fw-bold">ID: <Codee>{userInfo.user_id}</Codee></h4>
                  <Button
                    variant="primary"
                    className="profile-action-btn profile-action-btn--primary"
                    onClick={() => navigate('/subscribe')}
                  >
                    Оплатить подписку
                  </Button>
                </div>
                <div className="card-footer text-center py-2">{subscriptionStatus}</div>
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12}>
              <div className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} style={{ borderRadius: '0.5rem' }}>
                <div className="card-body p-3">
                  {publicProfileError && (
                    <div className="profile-glass-alert profile-glass-alert--danger py-2 mb-3" role="alert">
                      {publicProfileError}
                    </div>
                  )}
                  {publicProfileInfo && (
                    <div className="profile-glass-alert profile-glass-alert--success py-2 mb-3" role="alert">
                      {publicProfileInfo}
                    </div>
                  )}

                  <button
                    type="button"
                    className={`profile-public-toggle ${theme === 'dark' ? 'profile-public-toggle--dark' : 'profile-public-toggle--light'}`}
                    onClick={() => setPublicProfileExpanded((prev) => !prev)}
                    aria-expanded={publicProfileExpanded}
                    aria-label="Развернуть публичный профиль"
                  >
                    <div className="profile-public-toggle-main">
                      {publicAvatarUrl ? (
                        <img
                          src={publicAvatarUrl}
                          alt="avatar"
                          className="profile-public-avatar"
                        />
                      ) : (
                        <div className="profile-public-avatar profile-public-avatar--fallback">
                          {publicProfileInitials}
                        </div>
                      )}
                      <div className="profile-public-toggle-text">
                        <div className="profile-public-toggle-title">Публичный профиль</div>
                        <div className="profile-public-toggle-subtitle">{publicProfileSummaryName}</div>
                        <div className="profile-public-toggle-handle">{publicProfileSummaryHandle}</div>
                      </div>
                    </div>
                    <ChevronDown className={`profile-public-toggle-icon ${publicProfileExpanded ? 'is-open' : ''}`} size={18} />
                  </button>

                  {publicProfileExpanded && (
                    <div className="profile-public-editor mt-3">
                      <div className="d-flex align-items-center gap-3 mb-3">
                        {publicAvatarUrl ? (
                          <img
                            src={publicAvatarUrl}
                            alt="avatar"
                            className="profile-public-avatar"
                          />
                        ) : (
                          <div className="profile-public-avatar profile-public-avatar--fallback">
                            {publicProfileInitials}
                          </div>
                        )}
                        <Form.Control
                          type="file"
                          accept="image/*"
                          onChange={(e) => setPublicAvatarFile(e.target.files?.[0] || null)}
                        />
                      </div>

                      <Row className="g-2">
                        <Col xs={12}>
                          <Form.Control
                            placeholder="Отображаемое имя"
                            maxLength={80}
                            value={publicDisplayName}
                            onChange={(e) => setPublicDisplayName(e.target.value)}
                          />
                        </Col>
                        <Col xs={12}>
                          <Form.Control
                            placeholder="Логин (без @)"
                            maxLength={32}
                            value={publicChatHandle}
                            onChange={(e) => setPublicChatHandle(e.target.value)}
                            autoComplete="off"
                            spellCheck={false}
                          />
                          <div className="profile-public-handle-rules">
                            Логин: 3-32 символа, латиница a-z, цифры 0-9 и знак _.
                          </div>
                          <div className={`profile-public-handle-state ${publicHandleValidationClass}`}>
                            {publicHandleValidation.text}
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form.Control
                            placeholder="Telegram (@username, t.me/...) или MAX (max.ru/...)"
                            maxLength={512}
                            value={publicContactLink}
                            onChange={(e) => setPublicContactLink(e.target.value)}
                          />
                          <div className="profile-public-handle-rules">
                            Для связи можно указать только Telegram или MAX.
                          </div>
                        </Col>
                        <Col xs={12}>
                          <Form.Control
                            as="textarea"
                            rows={2}
                            placeholder="О себе"
                            maxLength={600}
                            value={publicBio}
                            onChange={(e) => setPublicBio(e.target.value)}
                          />
                        </Col>
                      </Row>

                      <div className="d-grid gap-2 mt-3">
                        <Button
                          variant="primary"
                          className="profile-action-btn profile-action-btn--primary"
                          onClick={handleSavePublicProfile}
                          disabled={publicProfileSaving || publicHandleValidation.state === 'checking'}
                        >
                          {publicProfileSaving ? 'Сохраняем...' : 'Сохранить публичный профиль'}
                        </Button>
                        <Link to="/my-market-items" className="btn profile-action-btn profile-action-btn--secondary">
                          Мои товары в барахолке
                        </Link>
                      </div>
                    </div>
                  )}
                  {!publicProfileExpanded && (
                    <div className="d-grid gap-2 mt-3">
                      <Link to="/my-market-items" className="btn profile-action-btn profile-action-btn--secondary">
                        Мои товары в барахолке
                      </Link>
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>

          <Row className="mb-3">
            <Col xs={12}>
              <div className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} style={{ borderRadius: '0.5rem' }}>
                <div className="card-body p-3">
                  <h5 className="fw-bold mb-3">{emailSectionTitle}</h5>
                  <div className="mb-2">
                    {profileEmailAuth ? (
                      <span>Текущий email: <strong>{profileEmailAuth}</strong></span>
                    ) : (
                      <span>Email пока не привязан</span>
                    )}
                  </div>
                  <div className={`profile-email-status mb-3 ${profileEmailVerified && !isEmailEditStep ? 'profile-email-status--ok' : 'profile-email-status--warning'}`}>
                    {emailVerificationStatusText}
                  </div>

                  {emailAuthError && (
                    <div className="profile-glass-alert profile-glass-alert--danger py-2 mb-3" role="alert">
                      {emailAuthError}
                    </div>
                  )}
                  {emailAuthInfo && !isEmailCodeStep && (
                    <div className="profile-glass-alert profile-glass-alert--success py-2 mb-3" role="alert">
                      {emailAuthInfo}
                    </div>
                  )}

                  {showVerifiedEmailActions && (
                    <div className="d-grid gap-2 mb-2">
                      <Button
                        variant="outline-primary"
                        className="profile-action-btn profile-action-btn--secondary"
                        onClick={() => {
                          setEmailAuthStep('edit');
                          setEmailAuthError('');
                          setEmailAuthInfo('');
                        }}
                        disabled={emailAuthLoading}
                      >
                        Изменить email
                      </Button>
                    </div>
                  )}

                  {showEmailInput && (
                    <>
                      <Form.Group className="mb-2">
                        <Form.Label className="mb-1">Email</Form.Label>
                        <Form.Control
                          type="email"
                          value={emailAuthInput}
                          onChange={(e) => setEmailAuthInput(e.target.value)}
                          placeholder="name@example.com"
                          disabled={emailAuthLoading}
                          autoComplete="email"
                        />
                      </Form.Group>

                      <div className="d-grid gap-2 mb-2">
                        <Button
                          variant="outline-primary"
                          className="profile-action-btn profile-action-btn--secondary"
                          onClick={handleSendProfileEmailCode}
                          disabled={emailAuthLoading}
                        >
                          {emailAuthLoading && (emailAuthStep === 'email' || isEmailEditStep) ? 'Отправляем...' : emailSendCodeButtonText}
                        </Button>
                      </div>
                    </>
                  )}

                  {isEmailCodeStep && (
                    <>
                      <div className="profile-glass-alert profile-glass-alert--success profile-email-code-hint py-2 mb-3" role="status">
                        Код отправлен на <strong>{emailAuthInput}</strong>. Проверьте входящие, спам и рассылки.
                      </div>
                      <Form.Group className="mb-2">
                        <Form.Label className="mb-1">Код из письма</Form.Label>
                        <Form.Control
                          type="text"
                          value={emailAuthCode}
                          onChange={(e) => setEmailAuthCode(e.target.value.replace(/[^\d]/g, '').slice(0, 6))}
                          placeholder="6 цифр"
                          disabled={emailAuthLoading}
                          inputMode="numeric"
                          autoComplete="one-time-code"
                        />
                      </Form.Group>
                      <div className="d-grid gap-2">
                        <Button
                          variant="primary"
                          className="profile-action-btn profile-action-btn--primary"
                          onClick={handleVerifyProfileEmailCode}
                          disabled={emailAuthLoading}
                        >
                          {emailAuthLoading ? 'Проверяем...' : 'Подтвердить код'}
                        </Button>
                        <Button
                          variant="link"
                          onClick={() => {
                            setEmailAuthStep('edit');
                            setEmailAuthCode('');
                            setEmailAuthError('');
                            setEmailAuthInfo('');
                          }}
                          disabled={emailAuthLoading}
                        >
                          Изменить email
                        </Button>
                      </div>
                    </>
                  )}

                  <hr className="my-3" />
                  <div className="d-flex justify-content-between align-items-center gap-3">
                    <div>
                      <div className="fw-bold">Telegram</div>
                      <div className={`profile-email-status profile-email-status--compact ${telegramLinked ? 'profile-email-status--ok' : 'profile-email-status--warning'}`}>
                        {telegramLinked ? 'Telegram привязан.' : 'Telegram не привязан.'}
                      </div>
                    </div>
                    {isEmailOnlyAccount && !telegramLinked && (
                      <Button
                        variant="outline-secondary"
                        className="profile-action-btn profile-action-btn--secondary"
                        onClick={handleStartTelegramLink}
                        disabled={telegramLinkLoading}
                      >
                        {telegramLinkLoading ? 'Открываем...' : 'Привязать Telegram'}
                      </Button>
                    )}
                  </div>

                  {telegramLinkStatus && !telegramLinked && (
                    <div className="small mt-2" style={{ color: theme === 'dark' ? '#adb5bd' : '#495057' }}>Статус привязки: {telegramLinkStatus}</div>
                  )}
                  {telegramLinkError && (
                    <div className="profile-glass-alert profile-glass-alert--danger py-2 mt-3 mb-0" role="alert">
                      {telegramLinkError}
                    </div>
                  )}
                  {telegramLinkInfo && (
                    <div className="small mt-2" style={{ color: theme === 'dark' ? '#adb5bd' : '#495057' }}>
                      {telegramLinkInfo}
                    </div>
                  )}
                </div>
              </div>
            </Col>
          </Row>


          <Row className="mb-3">
            <Col xs={12}>
              <div className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} style={{ borderRadius: '0.5rem' }}>
                <div className="card-body p-3">
                  <div className="d-flex align-items-center gap-2 mb-2">
                    <QuestionCircle size={20} />
                    <h5 className="fw-bold mb-0">Поддержка</h5>
                  </div>
                  <div className="small mb-3" style={{ color: theme === 'dark' ? '#adb5bd' : '#495057' }}>
                    Если возникли вопросы или проблемы, напишите нам в удобный мессенджер.
                  </div>
                  <div className="d-grid gap-2">
                    <Button
                      variant="outline-primary"
                      className="profile-action-btn profile-action-btn--secondary"
                      href={supportTelegramUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Написать в Telegram
                    </Button>
                    <Button
                      variant="outline-primary"
                      className="profile-action-btn profile-action-btn--secondary"
                      href={supportMaxUrl}
                      target="_blank"
                      rel="noreferrer"
                    >
                      Написать в MAX
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>


          {/* Реферальная программа */}
          <Row className="mb-3">
            <Col xs={12}>
              <div className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} style={{ borderRadius: '0.5rem' }}>
                <div className="card-body p-3">
                  <h2 className="text-center fw-bold mb-4" style={{ fontSize: '1.5rem' }}>Реферальная программа</h2>
                  <div className="d-flex justify-content-around">
                    <div className="text-center px-2" style={{ minWidth: '80px' }}>
                      <h1 style={{ fontWeight: 800 }}>{referalInfo ? referalInfo[0] : '0'}</h1>
                      <h6 className="text-center" style={{ color: 'grey', fontWeight: 200 }}>Рефералов</h6>
                    </div>
                    <div className="text-center px-2" style={{ minWidth: '80px' }}>
                      <h1 style={{ fontWeight: 800 }}>{referalInfo ? referalInfo[1] : '0'}</h1>
                      <h6 className="text-center" style={{ color: 'grey', fontWeight: 200 }}>Активных</h6>
                    </div>
                    <div className="text-center px-2" style={{ minWidth: '80px' }}>
                      <h1 style={{ fontWeight: 800 }}>{userInfo.balance}₽</h1>
                      <h6 className="text-center" style={{ color: 'grey', fontWeight: 200 }}>Баланс</h6>
                    </div>
                  </div>
                  <div className="d-flex justify-content-around gap-3 mt-4">
                    <Button
                      variant="outline-primary"
                      onClick={handleShare}
                      className="flex-grow-1 profile-action-btn profile-action-btn--primary"
                    >
                      Поделиться <Share size={20} />
                    </Button>
                    <Button
                      variant="outline-primary"
                      onClick={() => setModalShow(true)}
                      className="flex-grow-1 profile-action-btn profile-action-btn--secondary"
                    >
                      Условия
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* Кнопки управления */}
          <Row className="mb-3">
            <Col xs={12}>
              <div className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`} style={{ borderRadius: '0.5rem' }}>
                <div className="card-body d-flex justify-content-around p-3">
                  <Button variant="transparent" onClick={toggleSound} className={`profile-quick-btn ${theme === 'dark' ? 'profile-quick-btn--dark' : 'profile-quick-btn--light'} d-flex flex-column align-items-center`}>
                    {isSoundEnabled ? <VolumeUp size={40} /> : <VolumeMute size={40} />}
                  </Button>
                  <Button variant="transparent" onClick={toggleTheme} className={`profile-quick-btn ${theme === 'dark' ? 'profile-quick-btn--dark' : 'profile-quick-btn--light'} d-flex flex-column align-items-center`}>
                    {theme === 'dark' ? <Sun size={40} /> : <MoonStars size={40} />}
                  </Button>
                  <Button variant="transparent" onClick={() => setShowFiltersModal(true)} className={`profile-quick-btn ${theme === 'dark' ? 'profile-quick-btn--dark' : 'profile-quick-btn--light'} d-flex flex-column align-items-center`}>
                    <Sliders size={40} />
                  </Button>
                </div>
                <div className="px-3 pb-3">
                  <div className={`profile-glass-mode-row ${theme === 'dark' ? 'profile-glass-mode-row--dark' : 'profile-glass-mode-row--light'}`}>
                    <div>
                      <div className="fw-semibold">Упрощенный интерфейс</div>
                      <div className="small opacity-75">Отключает стекло и blur, чтобы приложение работало быстрее</div>
                    </div>
                    <Button
                      type="button"
                      variant="transparent"
                      onClick={handleGlassModeToggle}
                      className={`profile-glass-mode-btn ${theme === 'dark' ? 'profile-glass-mode-btn--dark' : 'profile-glass-mode-btn--light'} ${isGlassDisabled ? 'is-active' : ''}`}
                    >
                      {isGlassDisabled ? 'Выкл' : 'Вкл'}
                    </Button>
                  </div>
                </div>
              </div>
            </Col>
          </Row>

          {/* 🆕 Блок "Мои устройства" */}
          {!loadingDevices && (
            <Row className="mb-3">
              <Col xs={12}>
                <div
                  className={`card shadow ${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`}
                  style={{
                    borderRadius: '0.75rem',
                    overflow: 'hidden',

                  }}
                >
                  <div className="card-body p-3">
                    <div className="d-flex justify-content-between align-items-center mb-3">
                      <h5 className="fw-bold mb-0">Подключенные устройства</h5>
                      <span className="badge bg-primary rounded-pill">
                        {devices.length} устройств
                      </span>
                    </div>

                    {devices.length === 0 ? (
                      <div className="text-center py-4">
                        <Display size={48} className="mb-2" />
                        <p className="mb-0" style={{ color: theme === 'dark' ? '#adb5bd' : '#495057' }}>
                          Устройств не найдено
                        </p>
                      </div>
                    ) : (
                      <div className="devices-list">
                        <TransitionGroup component={null}>
                          {devices.map((dev) => (
                            <CSSTransition
                              key={dev.id}
                              timeout={300}
                              classNames="device-item"
                              in={exitingDeviceId !== dev.id}
                              unmountOnExit
                            >
                              <div
                                className={`device-card d-flex justify-content-between align-items-center p-3 mb-3 ${theme === 'dark' ? 'bg-gray-800' : 'bg-white'} rounded shadow-sm`}
                                style={{
                                  transition: 'all 0.3s ease',
                                  borderLeft: `4px solid ${dev.session_id === currentDeviceId ? '#0d6efd' : '#6c757d'}`,
                                  opacity: exitingDeviceId === dev.id ? 0 : 1,
                                  transform: exitingDeviceId === dev.id ? 'translateX(-100%)' : 'translateX(0)'
                                }}
                              >
                                <div className="d-flex align-items-center">
                                  <div className="device-icon me-3">
                                    {getDeviceIcon(dev.human_name)}
                                  </div>
                                  <div>
                                    <div className="fw-medium">
                                      {dev.human_name || 'Неизвестное устройство'}
                                    </div>
                                    <div className="small">
                                      {dev.session_id === currentDeviceId
                                        ? 'Текущее устройство'
                                        : ''}
                                    </div>
                                  </div>
                                </div>

                                <Button
                                  variant="outline-danger"
                                  size="sm"
                                  className="device-delete-btn"
                                  disabled={dev.session_id === currentDeviceId || exitingDeviceId === dev.id}
                                  onClick={() => handleDeleteDevice(dev.id)}
                                  title={
                                    dev.session_id === currentDeviceId
                                      ? 'Нельзя удалить текущее устройство'
                                      : 'Отключить устройство'
                                  }
                                >
                                  <Trash size={16} />
                                </Button>
                              </div>
                            </CSSTransition>
                          ))}
                        </TransitionGroup>
                      </div>
                    )}
                    <div className={`mt-3 text-center ${theme === 'dark' ? 'text-white-50' : 'text-muted'}`}>
                      <div>Авторизация: до 3 устройств на одного пользователя.</div>
                      <div class="mt-3 small text-center">
                        Доступ персональный: три устройства — это ваши телефон/планшет/ПК.
                        Делиться аккаунтом с другими нельзя (шеринг запрещён иначе бан).
                      </div>
                    </div>
                  </div>
                </div>
              </Col>
            </Row>
          )}
          {/* Выход */}
          <div className={`${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'}`}>
            <div className="card-body d-flex justify-content-center p-2">
              <Button
                variant="outline-danger"
                className="profile-action-btn profile-action-btn--danger"
                onClick={() => logout()}
                style={{ width: '30%', padding: '0.5rem 1rem' }}
              >
                Выйти
              </Button>
            </div>
          </div>
        </Container>

        <BottomNav />
      </div>

      <EmailDeliveryHintAlert
        show={showEmailDeliveryHint}
        isDark={theme === 'dark'}
        onClose={() => setShowEmailDeliveryHint(false)}
      />

      <Modal
        show={modalShow}
        onHide={() => setModalShow(false)}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={
            theme === 'dark'
              ? 'border-bottom border-secondary bg-dark text-white'
              : 'border-bottom border-secondary bg-light text-black'
          }
          style={{
            background:
              theme === 'dark'
                ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)'
                : 'linear-gradient(135deg, #fff, #f8f9fa)',
            padding: '12px',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Modal.Title style={{ fontWeight: 'bold', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
            ✨ Новые условия реферальной программы ✨
          </Modal.Title>
          <CloseButton
            onClick={() => setModalShow(false)}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>

        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'text-black bg-light'}
          style={{
            padding: '12px',
            background:
              theme === 'dark'
                ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)'
                : 'linear-gradient(135deg, #fff, #f8f9fa)',
            borderRadius: '0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            color: theme === 'dark' ? '#fff' : '#333',
            fontSize: '1rem',
            lineHeight: '1.6',
          }}
        >
          {/* БОНУСЫ */}
          <div className="mb-3">
            <h5 style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              🎁 Как получать бонусы
            </h5>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                <span style={{ color: '#0d6efd' }}>50 % с первой оплаты:</span><br />
                Когда приглашённый оформляет подписку впервые, вы получаете <strong>половину суммы</strong> сразу.<br />
                <em>Пример: тариф 300 ₽ → бонус 150 ₽.</em>
              </li>
              <li style={{ marginBottom: '6px' }}>
                <span style={{ color: '#0d6efd' }}>10 – 40 % со всех следующих оплат:</span><br />
                Процент зависит от того, сколько ваших друзей <strong>сейчас</strong> имеют активную подписку:<br />
                <ul style={{ listStyleType: 'none', padding: 0 }}>
                  <li>0-9 — 10 %</li>
                  <li>10-49 — 15 %</li>
                  <li>50-199 — 25 %</li>
                  <li>200-499 — 35 %</li>
                  <li>500+ — 40 %</li>
                </ul>
                <em>Пример: при 52 активных подписках ваш процент 25 %. Продление 1350 ₽ приносит 337,50 ₽.</em>
              </li>
            </ul>
          </div>

          {/* ВЫВОД ДЕНЕГ */}
          <div className="mb-3">
            <h5 style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              💸 Как вывести деньги
            </h5>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                Минимальная сумма к выводу — <strong>300 ₽</strong>.
              </li>
              <li style={{ marginBottom: '6px' }}>
                Кнопка вывода активна, если за <strong>последние 30 дней</strong> у ваших рефералов была хотя бы <strong>одна первая оплата</strong>.
              </li>
            </ul>
          </div>

          {/* АКТИВНЫЙ РЕФЕРАЛ */}
          <div className="mb-3">
            <h5 style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              ❗ Кто считается активным рефералом
            </h5>
            <p style={{ marginBottom: '6px' }}>
              Пользователь, который:<br />
              1️⃣ перешёл в бота <u>по вашей ссылке</u> и<br />
              2️⃣ <u>сейчас имеет активную подписку</u>.
            </p>
          </div>

          {/* ВАЖНО */}
          <div className="mb-3">
            <h5 style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
              ⚠️ Важно
            </h5>
            <ul style={{ listStyleType: 'none', padding: 0 }}>
              <li style={{ marginBottom: '6px' }}>
                Рефералом считается только тот, кто <strong>впервые</strong> зашёл в бота по вашей ссылке.
              </li>
              <li style={{ marginBottom: '6px' }}>
                Бонусы <u>не начисляются</u> за оплату по акционным ценам (если иное не указано в акции).
              </li>
            </ul>
          </div>

          {/* ССЫЛКИ */}
          <div className="mb-3">
            <p style={{ marginBottom: '6px' }}>
              <span style={{ color: '#0d6efd' }}>Ваша реферальная ссылка:</span>{' '}
              <a href={pwaReferralLink || `${PUBLIC_URL}/r/${userInfo.user_id}`} target="_blank" rel="noopener noreferrer">
                {pwaReferralLink || `${PUBLIC_URL}/r/${userInfo.user_id}`}
              </a>
            </p>
            {telegramReferralLink && (
              <p style={{ marginBottom: '6px' }}>
                <span style={{ color: '#0d6efd' }}>Telegram-ссылка (резерв):</span>{' '}
                <a href={telegramReferralLink} target="_blank" rel="noopener noreferrer">
                  {telegramReferralLink}
                </a>
              </p>
            )}
            <p style={{ marginBottom: '6px' }}>
              <span style={{ color: '#0d6efd' }}>Материалы для рекламы:</span>{' '}
              <a href="tg://resolve?domain=salew_catch" target="_blank" rel="noopener noreferrer">
                https://t.me/salew_catch
              </a>
            </p>
          </div>
        </Modal.Body>
      </Modal>


      <Modal
        show={showFiltersModal}
        onHide={handleModalClose}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-black modal-light'}
        size="lg"
        centered
        dialogClassName="modal-fixed-footer" // Добавляем кастомный класс для стилизации
      >
        <Modal.Header
          className={`${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'} border-0`}
          style={{ padding: '1.5rem', borderTopLeftRadius: '1rem', borderTopRightRadius: '1rem' }}
        >
          <Modal.Title as="h4" className="fw-bold">
            <Sliders className="me-2" size={24} /> Настройка фильтров
          </Modal.Title>
          <CloseButton
            onClick={handleModalClose}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>

        <Modal.Body
          className={`${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'} py-3`}
        >
          <div className="sb-inline-cta">
            <Link to="/videos" className="sb-mini-link sb-mini-link--video" aria-label="Видеоинструкция">
              <PlayCircle size={16} /> Видеоинструкция
            </Link>
          </div>
          <Card
            className={`${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'} shadow-sm mb-3`}
            style={{
              borderRadius: '0.75rem',
              border: theme === 'dark' ? '1px solid #444' : '1px solid #e0e0e0',
            }}
          >
            <Card.Body className="p-3">
              <div className="d-flex align-items-center justify-content-between">
                <div className="d-flex align-items-center gap-2">
                  <Sliders size={18} />
                  <span className="fw-bold">WB массовая настройка</span>
                </div>
                <Button
                  variant={theme === 'dark' ? 'outline-light' : 'outline-primary'}
                  size="sm"
                  onClick={() => setShowBulkWb((prev) => !prev)}
                >
                  {showBulkWb ? 'Скрыть' : 'Показать'}
                </Button>
              </div>

              {showBulkWb && (
                <>
                  <Row className="mt-3 gy-2 gx-2">
                    <Col xs={12} md={4}>
                      <Form.Check
                        type="switch"
                        id="wb-bulk-status"
                        label="Статус категории"
                        checked={bulkWbSettings.status_categ}
                        onChange={(e) => handleBulkWbChange('status_categ', e.target.checked)}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Check
                        type="switch"
                        id="wb-bulk-push"
                        label="Push"
                        checked={bulkWbSettings.push}
                        onChange={(e) => handleBulkWbChange('push', e.target.checked)}
                      />
                    </Col>


                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label className="mb-1">Скидка</Form.Label>
                        <Form.Select
                          value={bulkWbSettings.sale}
                          onChange={(e) => handleBulkWbChange('sale', parseInt(e.target.value))}
                          style={{
                            borderRadius: '0.5rem',
                            backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                            borderColor: theme === 'dark' ? '#444' : '#ddd',
                            color: theme === 'dark' ? '#fff' : '#000',
                          }}
                        >
                          {[...Array(10)].map((_, i) => (
                            <option key={i * 10} value={i * 10}>{i * 10}%</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label className="mb-1">AI</Form.Label>
                        <Form.Select
                          value={bulkWbSettings.ai}
                          onChange={(e) => handleBulkWbChange('ai', parseInt(e.target.value))}
                          style={{
                            borderRadius: '0.5rem',
                            backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                            borderColor: theme === 'dark' ? '#444' : '#ddd',
                            color: theme === 'dark' ? '#fff' : '#000',
                          }}
                        >
                          {[0, 1, ...Array.from({ length: 10 }, (_, i) => (i + 1) * 10)].map((value) => (
                            <option key={value} value={value}>{value}%</option>
                          ))}
                        </Form.Select>
                      </Form.Group>
                    </Col>

                    <Col xs={12} md={4}>
                      <Form.Check
                        type="checkbox"
                        id="wb-bulk-status-feedbacks"
                        label="Рубли за отзыв"
                        checked={bulkWbSettings.status_feedbacks}
                        onChange={(e) => handleBulkWbChange('status_feedbacks', e.target.checked)}
                      />
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label className="mb-1">% выгоды (рубли за отзыв)
                        </Form.Label>
                        <Form.Select
                          value={bulkWbSettings.feedbackminpercent}
                          onChange={(e) => handleBulkWbChange('feedbackminpercent', parseInt(e.target.value))}
                          style={{
                            borderRadius: '0.5rem',
                            backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                            borderColor: theme === 'dark' ? '#444' : '#ddd',
                            color: theme === 'dark' ? '#fff' : '#000',
                          }}
                        >
                          {[...Array(6)].map((_, i) => {
                            const val = 50 + i * 10;
                            return <option key={val} value={val}>{val}%</option>;
                          })}
                        </Form.Select>
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Check
                        type="checkbox"
                        id="wb-bulk-unref"
                        label="Невозвратные"
                        checked={bulkWbSettings.unrefusableallowed}
                        onChange={(e) => handleBulkWbChange('unrefusableallowed', e.target.checked)}
                      />
                    </Col>

                    <Col xs={12} md={4}>
                      <Form.Group>
                        <Form.Label className="mb-1">Остаток</Form.Label>
                        <Form.Control
                          type="number"
                          min={0}
                          value={bulkWbSettings.ostatok}
                          onChange={(e) => handleBulkWbChange('ostatok', parseInt(e.target.value))}
                          style={{
                            borderRadius: '0.5rem',
                            backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                            borderColor: theme === 'dark' ? '#444' : '#ddd',
                            color: theme === 'dark' ? '#fff' : '#000',
                          }}
                        />
                      </Form.Group>
                    </Col>
                    <Col xs={12} md={4}>
                      <Form.Check
                        type="checkbox"
                        id="wb-bulk-prod"
                        label="Склад продавца"
                        checked={bulkWbSettings.prod}
                        onChange={(e) => handleBulkWbChange('prod', e.target.checked)}
                      />
                    </Col>
                  </Row>
                  <div className="d-flex justify-content-between align-items-center mt-3">
                    <small style={{ color: theme === 'dark' ? '#adb5bd' : '#495057' }}>
                      Применяет ко всем WB. Отдельные карточки ниже обновятся сразу.
                    </small>
                    <Button size="sm" variant="primary" onClick={applyBulkWbSettings}>
                      Применить на все WB
                    </Button>
                  </div>
                </>
              )}
            </Card.Body>
          </Card>
          <Container fluid>
            <Row>
              {localFilters.map((filter, index) => (
                <Col key={index} xs={12} sm={6} md={6} lg={6} xl={4} className="mb-4">
                  <Card
                    className={`${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-dark'} shadow-sm`}
                    style={{
                      borderRadius: '0.75rem',
                      opacity: filter.status_categ ? 1 : 0.5,
                      transition: 'all 0.2s ease',
                      border: filter.status_categ ? '1px solid #0d6efd' : '1px solid rgb(107, 107, 107)',
                      backgroundColor: theme === 'dark' ? '#1e1e1e' : '#fff',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.transform = 'scale(1.02)')}
                    onMouseLeave={(e) => (e.currentTarget.style.transform = 'scale(1)')}
                  >
                    <Card.Body className="p-3">
                      {/* Ваш код Card.Body остаётся без изменений */}
                      <div className="d-flex justify-content-between align-items-center mb-3">
                        <h6
                          className="fw-bold mb-0"
                          style={{ fontSize: '1.1rem', color: theme === 'dark' ? '#fff' : '#2a2a2a' }}
                        >
                          {filter.categ}
                        </h6>
                        <Form.Check
                          type="switch"
                          id={`status-categ-${index}`}
                          checked={filter.status_categ}
                          onChange={(e) => handleFilterChange(index, 'status_categ', e.target.checked)}
                          className="custom-switch"
                        />
                      </div>

                      <Form.Group className="mb-2">
                        <Form.Check
                          type="checkbox"
                          label="Push уведомления"
                          checked={filter.push}
                          onChange={(e) => handleFilterChange(index, 'push', e.target.checked)}
                          className="fw-medium"
                          style={{ color: theme === 'dark' ? '#adb5bd' : '#6c757d' }}
                        />
                      </Form.Group>

                      <Form.Group className="mb-2">
                        <div className="d-flex align-items-center justify-content-between">
                          <Form.Label className="mb-0 fw-medium d-flex align-items-center gap-1">
                            <span className="me-1" style={{ fontSize: '1.2rem' }}>💸</span> Скидка

                            <InfoCircle
                              size={20}
                              color="#0d6efd"
                              style={{ cursor: 'pointer', transition: 'color 0.2s' }}
                              className="info-icon"
                              onClick={() => setSaleHelpModal(true)}
                            />
                          </Form.Label>
                        </div>
                        <Form.Select
                          value={filter.sale}
                          onChange={(e) => handleFilterChange(index, 'sale', parseInt(e.target.value))}
                          className="mt-1"
                          style={{
                            borderRadius: '0.5rem',
                            backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                            borderColor: theme === 'dark' ? '#444' : '#ddd',
                            color: theme === 'dark' ? '#fff' : '#000',
                          }}
                        >
                          {[...Array(10)].map((_, i) => (
                            <option key={i * 10} value={i * 10}>{i * 10}%</option>
                          ))}
                        </Form.Select>
                      </Form.Group>


                      {filter.categ !== 'Ozon' && filter.categ !== 'Detmir' && filter.categ !== 'Yandex' && (
                        <>
                          <Form.Group className="mb-2">
                            <Form.Label className="fw-medium d-flex align-items-center gap-1">
                              <span className="me-1" style={{ fontSize: '1.2rem' }}>🤖</span> AI прогноз

                              <InfoCircle
                                size={20}
                                color="#0d6efd"
                                style={{ cursor: 'pointer', transition: 'color 0.2s' }}
                                className="info-icon"
                                onClick={() => setAiHelpModal(true)}
                              />
                            </Form.Label>
                            <Form.Select
                              value={filter.ai}
                              onChange={(e) => handleFilterChange(index, 'ai', parseInt(e.target.value))}
                              className="mt-1"
                              style={{
                                borderRadius: '0.5rem',
                                backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                                borderColor: theme === 'dark' ? '#444' : '#ddd',
                                color: theme === 'dark' ? '#fff' : '#000',
                              }}
                            >
                              {[0, 1, ...Array.from({ length: 10 }, (_, i) => (i + 1) * 10)].map((value) => (
                                <option key={value} value={value}>{value}%</option>
                              ))}
                            </Form.Select>
                          </Form.Group>



                          <Form.Group className="mb-2">
                            <Form.Check
                              type="checkbox"
                              label="Рубли за отзыв"
                              checked={filter.status_feedbacks}
                              onChange={(e) => handleFilterChange(index, 'status_feedbacks', e.target.checked)}
                              className="fw-medium"
                              style={{ color: theme === 'dark' ? '#adb5bd' : '#6c757d' }}
                            />
                          </Form.Group>


                          <Form.Group className="mb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <Form.Label className="fw-medium d-flex align-items-center gap-1">
                                <span className="me-1" style={{ fontSize: '1.2rem' }}>📖</span> Руководство (рубли за отзыв)
                                <InfoCircle
                                  size={20}
                                  color="#0d6efd"
                                  style={{ cursor: 'pointer', transition: 'color 0.2s' }}
                                  className="info-icon"
                                  onClick={() => setShowGuideModal(true)}
                                />
                              </Form.Label>
                            </div>
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <div className="d-flex align-items-center justify-content-between">
                              <Form.Label className="fw-medium d-flex align-items-center gap-1">
                                <span className="me-1" style={{ fontSize: '1.2rem' }}>🤑</span>
                                % выгоды (рубли за отзыв)

                                <InfoCircle
                                  size={20}
                                  color="#0d6efd"
                                  style={{ cursor: 'pointer', transition: 'color 0.2s' }}
                                  className="info-icon"
                                  onClick={() => setBenefitHelpModal(true)}
                                />
                              </Form.Label>
                            </div>
                            <Form.Select
                              value={filter.feedbackminpercent}
                              onChange={e => handleFilterChange(index, 'feedbackminpercent', parseInt(e.target.value))}
                              className="mt-1"
                              style={{
                                borderRadius: '0.5rem',
                                backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                                borderColor: theme === 'dark' ? '#444' : '#ddd',
                                color: theme === 'dark' ? '#fff' : '#000',
                              }}
                            >
                              {[...Array(6)].map((_, i) => {
                                const val = 50 + i * 10;
                                return <option key={val} value={val}>{val}%</option>;
                              })}
                            </Form.Select>
                            {errors[index]?.feedbackminpercent && (
                              <div className="text-danger small mt-1">{errors[index].feedbackminpercent}</div>
                            )}
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Check
                              type="checkbox"
                              label="Показывать невозвратные товары"
                              checked={filter.unrefusableallowed}
                              onChange={e => handleFilterChange(index, 'unrefusableallowed', e.target.checked)}
                              className="fw-medium d-flex align-items-center gap-1"
                              style={{ color: theme === 'dark' ? '#adb5bd' : '#6c757d' }}
                            />
                            <InfoCircle
                              size={20}
                              color="#0d6efd"
                              style={{ cursor: 'pointer', transition: 'color 0.2s' }}
                              className="info-icon ms-1"
                              onClick={() => setUnrefHelpModal(true)}
                            />
                          </Form.Group>
                          <Form.Group className="mb-2">
                            <Form.Label className="fw-medium d-flex align-items-center gap-1">
                              <span className="me-1" style={{ fontSize: '1.2rem' }}>📦</span> Остаток
                            </Form.Label>
                            <Form.Control
                              type="number"
                              value={filter.ostatok}
                              onChange={(e) => handleFilterChange(index, 'ostatok', parseInt(e.target.value))}
                              isInvalid={errors[index]?.ostatok}
                              style={{
                                borderRadius: '0.5rem',
                                backgroundColor: theme === 'dark' ? 'rgba(39, 55, 72, 0.74)' : 'rgba(255, 255, 255, 0.7)',
                                borderColor: theme === 'dark' ? '#444' : '#ddd',
                                color: theme === 'dark' ? '#fff' : '#000',
                              }}
                            />
                            {errors[index]?.ostatok && (
                              <div className="text-danger small mt-1">{errors[index].ostatok}</div>
                            )}
                          </Form.Group>

                          <Form.Group>
                            <Form.Check
                              type="checkbox"
                              label="Склад продавца"
                              checked={filter.prod}
                              onChange={(e) => handleFilterChange(index, 'prod', e.target.checked)}
                              className="fw-medium"
                              style={{ color: theme === 'dark' ? '#adb5bd' : '#6c757d' }}
                            />
                          </Form.Group>
                        </>
                      )}
                    </Card.Body>
                  </Card>
                </Col>
              ))}
            </Row>
          </Container>
        </Modal.Body>

        <Modal.Footer
          className={`${theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'} border-0 d-flex justify-content-between py-3 px-4`}
          style={{
            position: 'sticky',
            bottom: 0,
            zIndex: 1, // Чтобы футер был поверх контента при скролле
            borderBottomLeftRadius: '1rem',
            borderBottomRightRadius: '1rem',
          }}
        >
          <div>
            <Button
              variant="outline-danger"
              onClick={handleResetFilters}
              className="me-2"
              style={{ borderRadius: '0.5rem', padding: '0.5rem 1rem' }}
            >
              Сбросить
            </Button>
            {hasBackupFilters && (
              <Button
                variant="outline-info"
                onClick={handleRestoreFilters}
                style={{ borderRadius: '0.5rem', padding: '0.5rem 1rem' }}
              >
                Вернуть
              </Button>
            )}
          </div>
          <Button
            variant="primary"
            onClick={handleSaveFilters}
            style={{ borderRadius: '0.5rem', padding: '0.5rem 2rem' }}
          >
            Сохранить
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={saleHelpModal}
        onHide={() => setSaleHelpModal(false)}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={
            theme === 'dark'
              ? 'border-bottom border-secondary bg-dark text-white'
              : 'border-bottom border-secondary bg-light text-black'
          }
        >
          <Modal.Title>💸 Как работает скидка</Modal.Title>
          <CloseButton
            onClick={() => setSaleHelpModal(false)}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
        >
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>📉 Расчёт:</span> скидка считается от{' '}
              <strong>минимальной цены диапазона</strong>, отслеживаемого годами.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Пример:</span> если минимальная цена —{' '}
              <strong>100 ₽</strong>, а скидка —{' '}
              <span style={{ color: '#16a34a' }}>10%</span>, товар появится при цене ≤{' '}
              <strong>90 ₽</strong>.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>0%:</span> показываются <strong>все товары</strong>, даже без
              скидок.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>&gt;0%:</span> только товары с{' '}
              <strong>реальной скидкой</strong> от минимальной цены.
            </li>
            <li>
              <span style={{ color: '#0d6efd' }}>Особенность:</span> для{' '}
              <strong>Ozon, Detmir, Yandex</strong> — от{' '}
              <span style={{ textDecoration: 'line-through' }}>зачёркнутой цены</span>.
            </li>
          </ul>
        </Modal.Body>
      </Modal>
      <Modal
        show={showGuideModal}
        onHide={() => setShowGuideModal(false)}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={
            theme === 'dark'
              ? 'border-bottom border-secondary bg-dark text-white'
              : 'border-bottom border-secondary bg-light text-black'
          }
        >
          <Modal.Title>🛒 Мини-руководство по товарам с баллами за отзыв на WB</Modal.Title>
          <CloseButton
            onClick={() => setShowGuideModal(false)}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
        >
          <p>✅ <strong>Как это работает:</strong></p>
          <ol>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Плашка есть:</span><br />
              - За этот товар ещё доступны баллы за отзыв<br />
              - Можно выкупить и оставить отзыв для получения баллов
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Плашки нет:</span><br />
              - При получении товара плашка появляется не сразу, только после получения в течении 3х дней.<br />
              - Если товар возвратный и плашка появилась в течение 3-х дней после получения — баллы начислят.<br />
              - Если товар возвратный и плашка не появилась за 14 дней, просто верните товар.<br />
              - Если товар не возвратный, лучше сразу убедиться, что плашка есть в карточке товара до выкупа.<br />
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Плашка появилась снова:</span><br />
              - Кто-то не оставил отзыв вовремя, отказался от товара или сделал возврат, место освободилось.<br />
              - Можно снова брать товар для отзыва
            </li>
          </ol>

          <p>✅ <strong>Дополнительные схемы:</strong></p>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>➡️ Перепродажа на Авито:</span><br />
              Получаете баллы за отзыв → выставляете на Авито → двойная прибыль
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>➡️ Возврат после получения баллов:</span><br />
              После начисления баллов можно вернуть товар, сохранив бонусы если срок возврата 14 дней не превышен.
            </li>
          </ul>

          <p>⚠️ <strong>Важно:</strong></p>
          <p>
            Если у вас не отображается плашка в приложении, проверяйте так же через браузер<br />
          </p>
        </Modal.Body>
      </Modal>
      {/* 🤖 AI */}
      <Modal
        show={aiHelpModal}
        onHide={() => setAiHelpModal(false)}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={
            theme === 'dark'
              ? 'border-bottom border-secondary bg-dark text-white'
              : 'border-bottom border-secondary bg-light text-black'
          }
        >
          <Modal.Title>🤖 AI (Искусственный интеллект)</Modal.Title>
          <CloseButton
            onClick={() => setAiHelpModal(false)}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
        >
          <p>
            AI анализирует скидки и продажи, предсказывая вероятность выкупа товара.
            Чем выше %, тем быстрее товар раскупят.
          </p>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Чем выше %:</span> тем быстрее товар раскупят.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Рекомендация:</span> для важных категорий используйте{' '}
              <span style={{ color: '#16a34a' }}>от 1%</span>, чтобы не пропустить ценные предложения.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Эксперименты:</span> для остальных категорий увеличивайте %, чтобы
              отфильтровать менее популярные товары.
            </li>
            <li>
              <span style={{ color: '#0d6efd' }}>Погрешность:</span> AI может ошибаться на новых или редких товарах, но
              мы регулярно обучаем модель на новых данных!
            </li>
          </ul>
        </Modal.Body>
      </Modal>
      {/* 🚫 Невозвратные товары */}
      <Modal
        show={unrefHelpModal}
        onHide={() => setUnrefHelpModal(false)}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={
            theme === 'dark'
              ? 'border-bottom border-secondary bg-dark text-white'
              : 'border-bottom border-secondary bg-light text-black'
          }
        >
          <Modal.Title>🚫 Невозвратные товары</Modal.Title>
          <CloseButton
            onClick={() => setUnrefHelpModal(false)}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
        >
          <p>
            Если вы включаете этот фильтр, бот будет показывать <strong>невозвратные</strong> товары <u>только среди
              позиций с рублями за отзыв</u>. Для обычных скидочных товаров параметр
            игнорируется.
          </p>

        </Modal.Body>
      </Modal>

      {/* 🤑 % выгоды */}
      <Modal
        show={benefitHelpModal}
        onHide={() => setBenefitHelpModal(false)}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={
            theme === 'dark'
              ? 'border-bottom border-secondary bg-dark text-white'
              : 'border-bottom border-secondary bg-light text-black'
          }
        >
          <Modal.Title>🤑 Мин. % выгоды (рубли за отзыв)</Modal.Title>
          <CloseButton
            onClick={() => setBenefitHelpModal(false)}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
        >
          <p>
            Это порог, с которого мы считаем, что «рубли за отзыв» дают реальную выгоду.
          </p>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Расчёт:</span> рубли за отзыв / цена товара * 100.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Пример:</span> <span style={{ color: '#16a34a' }}>200₽/250₽*100=80%</span> —
              товар покажется, если фильтр выбран <span style={{ color: '#16a34a' }}>≥80%</span>.
            </li>
            <li className="mb-2">
              <span style={{ color: '#0d6efd' }}>Логика фильтрации:</span>
              <ul className="mt-1">
                <li>
                  <span style={{ color: '#0d6efd' }}>Выгода ≤ 50%:</span> товар проходит остальные фильтры (скидка, AI,
                  остаток и т.д.).
                </li>
                <li>
                  <span style={{ color: '#0d6efd' }}>Выгода ≥ 50%:</span> товар проходит только фильтры Мин. % выгоды,
                  фильтры скидки и AI игнорируются.
                </li>
              </ul>
            </li>
          </ul>
        </Modal.Body>
      </Modal>
      {/* Новое модальное окно для пояснения при изменении скидки */}
      <Modal
        show={showInfoModal}
        onHide={handleInfoModalCancel}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={theme === 'dark' ? 'border-bottom border-secondary bg-dark text-white' : 'border-bottom border-secondary bg-light text-black'}
          style={{
            background: theme === 'dark' ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)' : 'linear-gradient(135deg, #fff, #f8f9fa)',
            padding: '12px',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Modal.Title style={{ fontWeight: 'bold', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
            Информация о скидке
          </Modal.Title>
          <CloseButton
            onClick={handleInfoModalCancel}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
          style={{
            padding: '12px',
            background: theme === 'dark' ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)' : 'linear-gradient(135deg, #fff, #f8f9fa)',
            borderRadius: '0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            color: theme === 'dark' ? '#fff' : '#333',
            fontSize: '1rem',
            lineHeight: '1.6',
          }}
        >
          <h5 style={{ fontWeight: 'bold', marginBottom: '10px', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
            Как считается скидка:
          </h5>
          <ul style={{ listStyleType: 'none', padding: 0 }}>
            <li style={{ marginBottom: '6px' }}>
              Скидка считается <span style={{ color: '#0d6efd' }}>от минимальной цены ДИАПАЗОНА</span>.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <span style={{ color: '#0d6efd' }}>Пример:</span> Если минимальная цена была <strong>100 ₽</strong> и вы указали скидку <span style={{ color: '#16a34a' }}>10%</span>, то товар отобразится только если его текущая цена ≤ <strong>90 ₽</strong>.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <span style={{ color: '#0d6efd' }}>При скидке 0%:</span> Отображаются <strong>все товары</strong>, даже те, у которых нет диапазона цен.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <span style={{ color: '#0d6efd' }}>Если скидка больше 0%:</span> Мы показываем только товары, которые действительно стали дешевле своей минимальной цены, а <strong>НЕ ОТ ЗАЧЕРКНУТОЙ ЦЕНЫ</strong>.
            </li>
            <li style={{ marginBottom: '6px' }}>
              <span style={{ color: '#0d6efd' }}>Особенность:</span> Для <strong>Ozon, Detmir и Yandex</strong> скидка рассчитывается от <span style={{ textDecoration: 'line-through' }}>зачёркнутой (старой) цены</span>.
            </li>
          </ul>
          <h6 style={{ marginTop: '10px', color: '#ffca2c', fontWeight: 'bold', fontSize: '1rem' }}>
            <span style={{ color: '#0d6efd' }}>Пример:</span> Если вчера утюг стоил 500 ₽ (минимальная цена), потом цена выросла, и сегодня снова 500 ₽, то при скидке больше 0% он не будет показан, так как не стал дешевле. Чтобы увидеть товар, его цена должна упасть ниже когда-то зафиксированного минимума.
          </h6>
        </Modal.Body>
        <Modal.Footer
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
          style={{
            background: theme === 'dark' ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)' : 'linear-gradient(135deg, #fff, #f8f9fa)',
            padding: '12px',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
          }}
        >
          <Button variant="secondary" onClick={handleInfoModalCancel}>
            Непонятно
          </Button>
          <Button variant="primary" onClick={handleInfoModalConfirm}>
            Понятно
          </Button>
        </Modal.Footer>
      </Modal>
      <Modal
        show={showAiInfoModal}
        onHide={handleAiInfoModalCancel}
        className={theme === 'dark' ? 'text-white modal-dark' : 'text-dark modal-light'}
      >
        <Modal.Header
          className={theme === 'dark' ? 'border-bottom border-secondary bg-dark text-white' : 'border-bottom border-secondary bg-light text-black'}
          style={{
            background: theme === 'dark' ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)' : 'linear-gradient(135deg, #fff, #f8f9fa)',
            padding: '12px',
            borderTopLeftRadius: '8px',
            borderTopRightRadius: '8px',
          }}
        >
          <Modal.Title style={{ fontWeight: 'bold', fontSize: '1.1rem', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>
            Вероятность быстрой распродажи (AI)
          </Modal.Title>
          <CloseButton
            onClick={handleAiInfoModalCancel}
            className={theme === 'dark' ? 'btn-close-white' : 'btn-close-black'}
          />
        </Modal.Header>
        <Modal.Body
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
          style={{
            padding: '12px',
            background: theme === 'dark' ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)' : 'linear-gradient(135deg, #fff, #f8f9fa)',
            borderRadius: '0',
            boxShadow: '0 2px 8px rgba(0,0,0,0.2)',
            color: theme === 'dark' ? '#fff' : '#333',
            fontSize: '1rem',
            lineHeight: '1.6',
          }}
        >
          <p style={{ marginBottom: '8px' }}>
            Нейросеть в процентах оценивает, насколько быстро выкупят товар. Чем выше значение, тем «горячее» предложение. Погрешность модели — около <span style={{ color: '#0d6efd' }}>20%</span>.
          </p>
          <p style={{ marginBottom: '8px' }}>
            Мы рекомендуем ставить фильтр в диапазоне <span style={{ color: '#16a34a' }}>60–80%</span>, но вы всегда можете экспериментировать.
          </p>
          <p style={{ marginBottom: '8px' }}>
            Если видите, что нейросеть промахнулась, не пугайтесь — это лишь модель, которая обучена на статистике. В основном она предсказывает достаточно точно, чтобы понять, что стоит взять в первую очередь.
          </p>
        </Modal.Body>
        <Modal.Footer
          className={theme === 'dark' ? 'bg-dark text-white' : 'bg-light text-black'}
          style={{
            background: theme === 'dark' ? 'linear-gradient(135deg, #2a2a2a, #1e1e1e)' : 'linear-gradient(135deg, #fff, #f8f9fa)',
            padding: '12px',
            borderBottomLeftRadius: '8px',
            borderBottomRightRadius: '8px',
          }}
        >
          <Button variant="secondary" onClick={handleAiInfoModalCancel}>
            Непонятно
          </Button>
          <Button variant="primary" onClick={handleAiInfoModalConfirm}>
            Понятно
          </Button>
        </Modal.Footer>
      </Modal>
    </>
  );
};

export default ProfilePage;



